<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <b-row>
            <b-col class="text-left d-flex align-items-center flex--wrap">
                <label>PTI Presuntivo {{ index + 1 }}</label>
            </b-col>
            <b-col class="text-right ">
                <b-button
                        v-if="!disable"
                        v-b-tooltip.hover title="Agregar Tratamiento"
                        variant="link"
                        @click="agregarTratamiento()">
                    <font-awesome-icon icon="plus-circle"/>
                </b-button>
                <b-dropdown  v-if="!disable" id="dropdown-1" dropleft size="sm" variant="link" class="m-md-2"
                            toggle-class="text-decoration-none" no-caret>
                    <template #button-content>
                        <font-awesome-icon icon="ellipsis-v"/>
                    </template>
                    <b-dropdown-group id="dropdown-group-1" header="Paquetes">
                        <b-dropdown-item v-if="paquetes.paquete1 !== undefined && paquetes.paquete1.length > 0" @click="cambiarPaquete(paquetes.paquete1)">Paquete 1</b-dropdown-item>
                        <b-dropdown-item v-if="paquetes.paquete2 !== undefined && paquetes.paquete2.length > 0" @click="cambiarPaquete(paquetes.paquete2)">Paquete 2</b-dropdown-item>
                        <b-dropdown-item v-if="paquetes.paquete3 !== undefined && paquetes.paquete3.length > 0" @click="cambiarPaquete(paquetes.paquete3)">Paquete 3</b-dropdown-item>
                    </b-dropdown-group>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="limpiar()">
                        <b-icon-trash></b-icon-trash>
                        Limpiar
                    </b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class=" mb-3" v-for="(item, i) in tratamientos"
                     :key="i">
                  <SelectTratamiento :item="item"
                                     :catTratamientos="catTratamientos"
                                     :editarE="editarE"
                                     :disable="disable"
                                     @actualizarRuta="actualizarRuta"
                                     :idEtapa="idEtapa"
                                     @eliminarTratamiento="eliminarTratamiento"
                                     :idPadecimiento="idPadecimiento"
                                     :i="index"
                                     @guardarBitacoraCambios="guardarBitacoraCambios"
                  ></SelectTratamiento>

                    <template v-if="editarE && idEtapa !== undefined &&  idEtapa !== null">
                        <v-select class="d-block" name="etapa" placeholder="Agregar etapa"
                                  v-model="item.etapa"
                                  :disabled="disable"
                                  :options="etapas"
                                  label="descripcion"
                        ></v-select>
                    </template>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>

import SelectTratamiento from "@/views/odontograma/detalleDiagnostico/SelectTratamiento";
export default {
    name: "HDXTratamientos",
  components: {SelectTratamiento},
  props: {
        disable: {
            type: Boolean,
            default: false
        },
        paquetes: null,
        tratamientos: null,
        catTratamientos: null,
        editarE: null,
        etapas: null,
        etapa: null,
        index: null,
        idPadecimiento: Number,
    },
    data: () => {
        return {
            version: process.env.VUE_APP_ENV_VERSION,
            debug: false,

            idEtapa: null,
            old: null,
            newData:null,
        }
    },
    created() {
        this.debug = this.$localStorageService.getDebug();

        this.idEtapa = this.$route.params.idEtapa
    },
    methods: {
      guardarBitacoraCambios(tipoMovimiento, idPadecimiento, idTratamiento){
        this.$emit('guardarBitacoraCambios', tipoMovimiento, idPadecimiento, idTratamiento)
      },
        cambiarPaquete(item) {
            this.$emit('cambiarPaquete', this.index, item)
        },
        agregarTratamiento() {
            this.tratamientos.push({idTratamiento: null, cantidad: 1, etapa: this.etapa, modificado: true})
        },
        eliminarTratamiento(item) {
            this.tratamientos.splice(this.tratamientos.indexOf(item), 1)
            this.$emit('guardarBitacoraCambios', 2, item.idPadecimento, item.idTratamiento)
            this.$emit('ruta')
        },
        actualizarRuta() {
            this.$emit('ruta')
        },
        limpiar() {
            this.$emit('limpiar', this.index)
        }
    }
}
</script>

<style scoped>
label {
    color: rgb(50, 50, 50) !important;
}
</style>
